import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { allSteps, getStepIndexByStepSlug } from './../../library/ProjectSteps';
import ProjectStep from './ProjectStep';
import styles from './ProjectStepsSidebar.scss';
const rootClassName = styles.rootClassName;

class ProjectStepsSidebar extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isMobile: false,
    };

    this.updateDimensions = this.updateDimensions.bind(this);
  }

  updateDimensions() {
    this.setState({
      ...this.state,
      isMobile: window.innerWidth < parseInt(styles.smSize) ? true : false,
    });
  }

  UNSAFE_componentWillMount() {
    this.updateDimensions();
  }

  componentDidMount() {
    window.addEventListener('resize', this.updateDimensions);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.updateDimensions);
  }

  isEditing() {
    return this.props.match.params && this.props.match.params.id ? true : false;
  }

  stepIsAllow(stepIndex) {
    if (this.props.auth.userPermissions.projetos.edit) {
      return true;
    }
    if (
      !this.isEditing() &&
      this.props.auth.userPermissions.projetos.register
    ) {
      if (stepIndex === 0) {
        return true;
      }
    }
  }

  render() {
    const activedStepIndex = getStepIndexByStepSlug(this.props.stepSlugName);
    let allowRender = false;
    allSteps.forEach((step, index) => {
      if (this.stepIsAllow(index)) {
        allowRender = true;
      }
      return step;
    });
    return allowRender && !this.state.isMobile ? (
      <div className={rootClassName}>
        {allSteps.map((step, index) => {
          return this.stepIsAllow(index) ? (
            <ProjectStep
              enabled={
                index <= this.props.projeto.avaliacoes.length ||
                  (index === 10 && this.props.projeto.avaliacoes.length >= 1)
                  ? true
                  : false
              }
              key={index}
              stepIndex={index}
              activedStepIndex={activedStepIndex}
            />
          ) : null;
        })}
      </div>
    ) : null;
  }
}

ProjectStepsSidebar.propTypes = {
  stepSlugName: PropTypes.string,
};

const mapStateToProps = (state) => ({
  languageValues: state.languages.languageValues,
  projeto: state.projeto.projetoEditing,
  auth: state.auth,
});

export default connect(mapStateToProps)(withRouter(ProjectStepsSidebar));
